import {PsdRules} from '../core/models/psd-rules';

export interface PsdRequirement {
  key: string;
  params?: Record<string, unknown>;
}

export function psdRequirements(rules: PsdRules): PsdRequirement[] {
  const requirements: PsdRequirement[] = [
    {key: 'changePsd.rules.minLength', params: {count: rules.minLength}},
  ];

  if (rules.requireLowercase) requirements.push({key: 'changePsd.rules.lowercase'});
  if (rules.requireUppercase) requirements.push({key: 'changePsd.rules.uppercase'});
  if (rules.requireDigit) requirements.push({key: 'changePsd.rules.digit'});
  if (rules.requireNonAlphanumeric) requirements.push({key: 'changePsd.rules.symbol'});
  if (rules.requiredUniqueChars > 1) {
    requirements.push({key: 'changePsd.rules.uniqueChars', params: {count: rules.requiredUniqueChars}});
  }

  return requirements;
}
